export default __webpack_public_path__ + "static/media/bg16.4c7a2ea6.jpg";